module.exports = __webpack_public_path__ + "img/footer_bg_proact.e40817e5.jpg";